import { render, staticRenderFns } from "./AppNavItem.vue?vue&type=template&id=2388f990&scoped=true&"
import script from "./AppNavItem.vue?vue&type=script&lang=js&"
export * from "./AppNavItem.vue?vue&type=script&lang=js&"
import style0 from "./AppNavItem.vue?vue&type=style&index=0&id=2388f990&scoped=true&lang=css&"
import style1 from "./AppNavItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388f990",
  null
  
)

export default component.exports